<app-breadcrumb [path]="'Pedido Realizado'" [showTitle]="true"></app-breadcrumb>
<div class="order-placed-main">
  <div class="container">
    <div class="order-placed-main-content">
      <h2>Pedido realizado!</h2>
      <h2>AGUARDANDO CONFIRMAÇÃO DE PAGAMENTO</h2>
      <div class="order-status">
        <div class="step completed">Pedido realizado</div>
        <div class="step pending">Aguardando confirmação</div>
      </div>
      <h3>Número do pedido: {{ order?.id }}</h3>
      <h3>Você receberá atualizações no e-mail:</h3>
      <h3>
        {{ order?.emailUser }}
      </h3>
      <a routerLink="/area-do-cliente/meus-pedidos">
        <button
          title="Acessar seus pedidos"
          aria-label="Acessar seus pedidos"
          class="button-rm"
        >
          ACOMPANHAR PEDIDO
        </button>
      </a>
    </div>
  </div>
</div>
